import React, { Component } from 'react'

export default class Square extends Component {
    render() {
        var classNameText = ""
        if (this.props.activeTabText === this.props.text) {
            classNameText = "tabFocus";
        } else {
            classNameText = "tab";
        }

        return (            
            <button className={classNameText}
                onClick={() => this.props.onClick()}
            >
                {this.props.text}
            </button>
        );
    }
}